export const BOOK_CALL_URL = 'https://outlook.office.com/bookwithme/user/ef4ea62f5f63468f81198434ca520df1@stray-apps.com/meetingtype/B3qQTndYfEukNSHGz8qbfg2?anonymous&ismsaljsauthenabled&ep=mlink';
